module.exports = __webpack_public_path__ + "img/Bed.ed008166.svg";